import { t } from 'i18next';
import {
  BottomLayer, ContainerBI, ContainerLoader,
} from './styles';
import { Loader } from '~/components';
import {
  useEffect, useRef, useState,
} from 'react';

export function ReturnIframe({
  url, height, width,
}: { url: string; height?: number; width?: number }): JSX.Element {
  const [isReady, setIsReady] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [hasError, setHasError] = useState(false);
  const handleIframeLoad = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsReady(true), 5000);
  };
  const handleIframeError = () => {
    setHasError(true);
    setIsReady(false);
  };

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return (
    <ContainerBI height={height} width={width}>
      <iframe
        key={url}
        ref={iframeRef}
        title="Dashboard Diel"
        src={url}
        width="100%"
        height="100%"
        style={{
          border: 'none',
          transform: 'scale(1.01)',
          transformOrigin: 'top center',
          display: hasError || !isReady ? 'none' : 'block',
        }}
        onLoad={handleIframeLoad}
        onError={handleIframeError}
        onContextMenu={(e) => e.preventDefault()}
      />
      {isReady && (
        <BottomLayer />
      )}

      {!isReady && (
        <ContainerLoader>
          <Loader />
          <p>{t('carregandoDados')}</p>
        </ContainerLoader>
      )}
      {hasError && (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <p>{t('erroRelatorio')}</p>
        </div>
      )}
    </ContainerBI>
  );
}
